/* @generated from adl module ferovinum.datacontracts.fxrate */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface FxRateRawRecord {
  ratesCurveId: common_strings.StringNE;
  code: common_strings.StringNE;
  baseCurrency: common_strings.StringNE;
  quoteCurrency: common_strings.StringNE;
  exchangeRate: common.BigDecimal;
  date: common.LocalDate;
  interpolation: common_strings.StringNE;
  period: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeFxRateRawRecord(
  input: {
    ratesCurveId: common_strings.StringNE,
    code: common_strings.StringNE,
    baseCurrency: common_strings.StringNE,
    quoteCurrency: common_strings.StringNE,
    exchangeRate: common.BigDecimal,
    date: common.LocalDate,
    interpolation: common_strings.StringNE,
    period: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): FxRateRawRecord {
  return {
    ratesCurveId: input.ratesCurveId,
    code: input.code,
    baseCurrency: input.baseCurrency,
    quoteCurrency: input.quoteCurrency,
    exchangeRate: input.exchangeRate,
    date: input.date,
    interpolation: input.interpolation,
    period: input.period,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const FxRateRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.fxrate","decl":{"annotations":[{"value":{"datasetName":"raw_fx_rate"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ratesCurveId","default":{"kind":"nothing"},"name":"ratesCurveId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"baseCurrency","default":{"kind":"nothing"},"name":"baseCurrency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"quoteCurrency","default":{"kind":"nothing"},"name":"quoteCurrency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"exchangeRate","default":{"kind":"nothing"},"name":"exchangeRate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"interpolation","default":{"kind":"nothing"},"name":"interpolation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"period","default":{"kind":"nothing"},"name":"period","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"FxRateRawRecord","version":{"kind":"nothing"}}};

export const snFxRateRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.fxrate", name:"FxRateRawRecord"};

export function texprFxRateRawRecord(): ADL.ATypeExpr<FxRateRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snFxRateRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.fxrate.FxRateRawRecord" : FxRateRawRecord_AST
};
